import { IdUser, API } from "./apiConfig";
export const getInsertMeetingSummary = (data) => {
  return API.post("UnitContent/Meeting/InsertNewMeeting", {
    ...data,
    IdUser,
  });
};
export const getUpdateMeetingSummary = (data) => {
  return API.post("UnitContent/Meeting/UpdateNewMeeting", {
    ...data,
    IdUser,
  });
};
export const getMeetingList = () => {
  return API.post("UnitContent/Meeting/MeetingList", {
    IdUser,
  });
};
export const getDeleteMeeting = (data) => {
  return API.post("UnitContent/Meeting/DeleteMeeting", {
    ...data,
    IdUser,
  });
};
export const getTicketsList = (keyId, PageNumber) => {
  return API.post("UnitMessaging/Ticket/MyTicketsList", {
    ...keyId,
    IdUser,
    PageNumber,
  });
};
// export const getFilteredTicketsList = (key) => {
//   return API.post("UnitMessaging/Ticket/MyTicketsList", {
//     IdUser,
//     key,
//   });
// };
export const getTicketsChat = (data) => {
  return API.post("UnitMessaging/Ticket/ShowTicket", {
    ...data,
    IdUser,
  });
};
export const getAnswerTicketByAdmin = (data) => {
  data.append("IdUser", IdUser);

  return API.post("UnitMessaging/Ticket/ResponseTicketByAdmin", data);
};

export const getAddTicket = (data) => {
  data.append("IdUser", IdUser);
  return API.post("UnitMessaging/Ticket/StoreTicketByAdmin", data);
};

export const getDepartementList = () => {
  return API.post("UnitMessaging/Ticket/DepartmentList", {
    IdUser: IdUser,
  });
};

export const getChangeDepartment = (data) => {
  return API.post("UnitMessaging/Ticket/ChangeDepartmentByAdmin", {
    ...data,
    IdUser,
  });
};

export const getCloseTicket = (data) => {
  return API.post("UnitMessaging/Ticket/CloseTicket", {
    ...data,
    IdUser,
  });
};

export const getReferTicket = (data) => {
  return API.post("UnitMessaging/Ticket/ReferralToAnotherAdmin", {
    ...data,
    IdUser,
  });
};
// export const getReferredChat = ()=>{

// }

export const getAllUsersRollCallList = (search) => {
  return API.post("UnitAccounting/RollCall/showRollCallListAllUser", {
    ...search,
    IdUser,
  });
};

export const setRollCall = (data) => {
  return API.post("UnitAccounting/RollCall/setRollCall", {
    ...data,
    IdUser,
  });
};

export const getUserRollCall = (data) => {
  return API.post("UnitAccounting/RollCall/showRollCallList", {
    ...data,
    IdUser,
  });
};

export const getTargetList = () => {
  return API.post("UnitManagement/Management/SaleTarget/SaleTargetList", {
    IdUser,
  });
};

export const getInsertNewTarget = (data) => {
  return API.post("UnitManagement/Management/SaleTarget/InsertNewSaleTarget", {
    ...data,
    IdUser,
  });
};

export const getDeleteTarget = (data) => {
  return API.post("UnitManagement/Management/SaleTarget/DeleteSaleTarget", {
    IdUser,
    ...data,
  });
};

export const getEditTarget = (data) => {
  return API.post("UnitManagement/Management/SaleTarget/UpdateSaleTarget", {
    IdUser,
    ...data,
  });
};

export const getSingleTarget = (id) => {
  return API.post("UnitManagement/Management/SaleTarget/ShowSaleTarget", {
    IdUser,
    ...id,
  });
};

export const getAddTargetUser = (data) => {
  return API.post(
    "UnitManagement/Management/SaleTarget/InsertNewUserSaleTarget",
    {
      IdUser,
      ...data,
    }
  );
};

export const getEditTargetUser = (data) => {
  return API.post("UnitManagement/Management/SaleTarget/UpdateUserSaleTarget", {
    IdUser,
    ...data,
  });
};

export const getDeleteTargetUser = (data) => {
  return API.post("UnitManagement/Management/SaleTarget/DeleteUserSaleTarget", {
    IdUser,
    ...data,
  });
};

export const sendNotifUpdateProduct = (IdEquivalent) => {
  const data = {
    IdUser,
    IdEquivalent,
  };
  return API.post("/UnitAccounting/SendNotifyUpdateDetailsOrder", data);
};

export const getInsertLeaveReq = (data) => {
  return API.post("/UnitManagement/Employee/LeaveRequest/InsertLeaveRequest", {
    IdUser,
    ...data,
  });
};

export const getLeaveReqList = () => {
  return API.post("/UnitManagement/Employee/LeaveRequest/MyLeaveRequestsList", {
    IdUser,
  });
};

export const getLeaveReqAdminList = () => {
  return API.post("/UnitManagement/Employee/LeaveRequest/LeaveRequestsList", {
    IdUser,
  });
};

export const getSingleLeaveReq = (data) => {
  return API.post("/UnitManagement/Employee/LeaveRequest/ShowLeaveRequest", {
    IdUser,
    ...data,
  });
};

export const getAccessLevelList = () => {
  return API.post("/UnitManagement/Management/AccessLevel/List");
};

export const getAddNewAccess = (data) => {
  return API.post("/UnitManagement/Management/AccessLevel/Insert", data);
};

export const getDeleteAccessItem = (data) => {
  return API.post("/UnitManagement/Management/AccessLevel/Delete", data);
};

export const getEditAccessItem = (data) => {
  return API.post("/UnitManagement/Management/AccessLevel/Update", data);
};
